import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CompaniesService {

  constructor(private _http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };


  getCompanies(): Observable<any> {
      console.log(this._http.get('/companies'));
      return this._http.get('/companies');
  }

  createCompany(data) {
      let body = JSON.stringify(data);
      return this._http.post('/companies/', body, this.httpOptions);
  }

  updateCompany(data) {
      let body = JSON.stringify(data);
      return this._http.put('/companies/' + data.id, body, this.httpOptions);
  }

  deleteCompany(data): Observable<any> {
      return this._http.delete('/companies/' + data.id);
  }

  getCompanyLogo(id: string) {
    return this._http.get('/companies/' + id + '/download/logo');
  }

  deleteLogo(data): Observable<any> {
    return this._http.get('/companies/' + data.id +'/delete/logo');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/companies/companies.service.ts